import React from 'react';

export const ReadyPage: React.FC = () => <div>Ready!</div>;
